import { Directive } from "@angular/core";

@Directive({
    selector: "[card-footer]",
    standalone: false,
})
export class DashboardFooterDirective {}
